import { _ as _toConsumableArray } from '../toConsumableArray-2a885c07.js';
import '../unsupportedIterableToArray-5baf4325.js';
var THEME_COLOR_STEPS = [25, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900];
var THEME_COLOR_PREFIXES_FULL = ['primary', 'gray', 'success', 'error', 'warning'];
var THEME_COLOR_PREFIXES_FIRST_CHAR = THEME_COLOR_PREFIXES_FULL.map(function (prefix) {
  return prefix[0];
});
var THEME_COLOR_PREFIXES = [].concat(_toConsumableArray(THEME_COLOR_PREFIXES_FIRST_CHAR), THEME_COLOR_PREFIXES_FULL);
export { THEME_COLOR_PREFIXES, THEME_COLOR_PREFIXES_FIRST_CHAR, THEME_COLOR_PREFIXES_FULL, THEME_COLOR_STEPS };